export const SERVER_DOWN = (
  'The server is currently undergoing maintenance. Please check back soon!'
);
